import React, { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import find_in_page from "../../../public/images/banner/find_in_page.svg";
import Separator from "@/components/Common/Separator";
import { ImmigrationGurusSvg } from "@/public/images/Svgs/ImmigirationsSvg";
import { ASSETS_URL } from "@/Constant";

const CourseSix = ({ Data, VisibleValue }) => {
  

  const buttonClass = {
    width: "100%",
    textAlign: "center",
    fontFamily: '"Noto Sans", sans-serif',
    fontWeight: 600,
    fontSize: "16px",
    color: "#000000",
    borderRadius: "56px",
    border: "1px solid #000000",
    padding: "13px 24px",
    cursor: "pointer",
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });

    // Add suffix for day (e.g., 1st, 2nd, 3rd)
    const daySuffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
        ? "rd"
        : "th";

    return `${day}${daySuffix} ${month}`;
  }

  function formatTime(timeString) {
    const [hour, minute] = timeString.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 || 12; // Convert 0 to 12 for 12-hour format

    return `${formattedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="tab-content " id="rbt-myTabContent">
            <div className="row g-5">
              {Data?.length > 0 ? (
                Data.map((data, index) => (
                  <div
                    className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12"
                    key={index}
                  >
                    <div className={`rbt-card variation-01 rbt-hover `}>
                      <div
                        className="rbt-card-img"
                        style={{
                          backgroundImage: `url(${ASSETS_URL}/${data?.banner})`, // Use the URL structure for the logo
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          backgroundColor: "#f3f3f3",
                          height: "250px",
                          maxHeight: "250px",
                        }}
                      ></div>
                      <div className="rbt-card-body">
                        <h4
                          className="rbt-card-title"
                          style={{
                            maxWidth: "200ch",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={data.title} // Tooltip to display full content
                        >
                          {data.title}
                        </h4>

                        <div className="rbt-card-bottom">
                          <div
                            style={{
                              display: "flex",
                              gap: "0.5rem",
                              marginTop: "0.5rem",
                            }}
                          >
                            <span
                              style={{
                                color: "#000000",
                                fontSize: "14px",
                                lineHeight: "30px",
                                fontWeight: "400",
                              }}
                            >
                              {formatDate(data.startdate)} -{" "}
                              {formatDate(data.enddate)},
                            </span>
                            <span
                              style={{
                                color: "#000000",
                                fontSize: "14px",
                                lineHeight: "30px",
                                fontWeight: "400",
                              }}
                            >
                              {formatTime(data.starttime)} -{" "}
                              {formatTime(data.endtime)}
                            </span>
                          </div>
                        </div>
                      </div>
                      <Separator />
                      <ul
                        className="rbt-sidebar-list-wrapper categories-list-check has-show-more-inner-content list-none"
                        style={{
                          listStyleType: "none",
                          paddingLeft: "0px",
                        }}
                      >
                        <li className="rbt-check-group">
                          <label
                            htmlFor="cat-list-3"
                            className="text-[1rem]"
                            style={{
                              display: "flex",
                              gap: 10,
                              justifyContent: "normal",
                              fontSize: "16px",
                            }}
                          >
                            <span
                              className="flex items-center"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {ImmigrationGurusSvg.locationSvg}
                            </span>{" "}
                            {data?.city} - {data?.country}
                          </label>
                        </li>
                        <li className="rbt-check-group">
                          <label
                            htmlFor="cat-list-4"
                            className="text-[1rem]"
                            style={{
                              display: "flex",
                              gap: 10,
                              justifyContent: "normal",
                              fontSize: "16px",
                            }}
                          >
                            <span
                              className="flex items-center"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {ImmigrationGurusSvg.worlddesignSvg}
                            </span>{" "}
                            {data?.destinations
                              ?.map((item) => item?.charAt(0) + item?.charAt(1))
                              ?.join(", ")}
                          </label>
                        </li>

                        <li className="rbt-check-group">
                          <label
                            htmlFor="cat-list-5"
                            className="text-[1rem]"
                            style={{
                              display: "flex",
                              gap: 10,
                              justifyContent: "normal",
                              fontSize: "16px",
                            }}
                          >
                            <span
                              className="flex items-center"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {ImmigrationGurusSvg.educationSvg}
                            </span>{" "}
                            {data?.studylevel?.map((item) => item)?.join(", ")}
                          </label>
                        </li>
                      </ul>

                      <Link
                        style={buttonClass}
                        className="mt--10 cursor-pointer hover:bg-blue-500  hovered_bg_colour event-register-btn"
                        href={`/events/${data?.id}`}
                      >
                        View & Register
                      </Link>
                    </div>
                  </div>
                ))
              ) : (
                <div
                  className="rbt-sidebar-widget-wrapper w-full"
                  style={{
                    minHeight: "400px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {" "}
                  <div className="flex flex-col items-center justify-center p-8 rounded-lg w-full max-w-md mx-auto my-8">
                    <div className="flex justify-center items-center mb-4"></div>
                    <div
                      className="flex gap-2 items-start"
                      style={{
                        display: "flex",
                        gap: "8px",
                      }}
                    >
                      <div className="mt-2">
                        <Image
                          src={find_in_page}
                          width={24}
                          height={24}
                          alt="Hero Image"
                        />
                      </div>
                      <div>
                        <span
                          style={{
                            color: "#4D4D4D",
                            fontWeight: "500",
                            fontSize: "26px",
                          }}
                        >
                          We couldn't find any Events
                        </span>
                        <ul
                          style={{
                            fontWeight: "400",
                            fontSize: "16px",
                            color: "#4D4D4D",
                          }}
                        >
                          <li>Check your filters and search for typos</li>
                          <li>Use more generic search terms</li>
                          <li>Reach out to us at info@immigurus.com for support</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CourseSix;
